import API_BASE from "../config";
import authHeader from "./auth-header";
import axios from "axios";

const API_URL = API_BASE + "/api/news";

// Public reads. Staff tokens (if present) also reveal unpublished rows.
// params e.g. { limit: 10 }
const getAll = (params = {}) =>
  axios.get(API_URL, { params, headers: authHeader() });

const get = (id) =>
  axios.get(`${API_URL}/${id}`, { headers: authHeader() });

// Moderator / admin writes.
const create = (data) =>
  axios.post(API_URL, data, { headers: authHeader() });

const update = (id, data) =>
  axios.put(`${API_URL}/${id}`, data, { headers: authHeader() });

const remove = (id) =>
  axios.delete(`${API_URL}/${id}`, { headers: authHeader() });

// Upload a cover image (max 2 MB). Returns { url } like "/img/news/x.jpg".
const uploadImage = (file, onProgress) => {
  const fd = new FormData();
  fd.append("image", file);
  return axios.post(`${API_URL}/upload-image`, fd, {
    headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded * 100) / e.total)),
  });
};

// Turn a stored image value into a usable src: server paths ("/img/news/..")
// get the API host prefixed; full URLs are returned unchanged.
export const newsImageSrc = (val) => {
  if (!val) return "";
  if (/^(https?:)?\/\//i.test(val) || val.startsWith("data:")) return val;
  return API_BASE + (val.startsWith("/") ? val : "/" + val);
};

const NewsService = { getAll, get, create, update, remove, uploadImage };

export default NewsService;
